export class MixerBgDeleteCmd {}
